module.exports = __webpack_public_path__ + "0409d7f48c4a5ac3bf1a4e3aad237f18.svg";